import {dashboardChartColors} from '../../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../../common/BarchartColumn';

export const prop = 'status';

export const config = (labels) =>
	barchartColumnConfig({
		id: 'misstatements',
		label: labels.MisstatementsLabel,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.reclassificationLabel,
				data: [item.misReclasCY],
				color: dashboardChartColors.purple[4]
			},
			{
				name: utilLabels.judgmentalLabel,
				data: [item.misJudgCY],
				color: dashboardChartColors.purple[3]
			},
			{
				name: utilLabels.projectedLabel,
				data: [item.misProjCY],
				color: dashboardChartColors.purple[2]
			},
			{
				name: utilLabels.factualLabel,
				data: [item.misFactCY],
				color: dashboardChartColors.purple[1]
			}
		]
	});
